import * as React from 'react'
import { connect } from 'react-redux'
import { RouterAction, routerActions } from 'react-router-redux'
import { StickyContainer, Sticky } from 'react-sticky'
import PerfectScrollbar from 'react-perfect-scrollbar'

import { AppBarContainer } from './CustomAppBar'
import { Job, Days, Slots } from '../types'

import { LoadingSpinner } from '../components/LoadingSpinner'
import PageTitle from '../components/PageTitle'
import { InfoDialog } from '../components/InfoDialog'

import { TIMES_2 } from '../constants/components/pickupTime'
import { ROUTES } from '../constants/routes'

import { setCompletedJob } from '../actions/setCompletedJob'
import { setSlots, setChips, setJobTimeInfo, removeJobDetails } from '../actions/setJobDetails'

import { StoreState } from '../reducers'

import '../styles/SetAvailability.scss'
import 'react-perfect-scrollbar/dist/css/styles.css'

import { Strings } from '../localization'
import { StringResources } from '../localization/StringResources'

import { BaseContainer } from './BaseContainer'
import { EventType } from '../services/events/events'

import moment from 'moment'
import ListItem from '@material-ui/core/ListItem'
import { Avatar, ListItemText } from '@material-ui/core'
import Chip from '@material-ui/core/Chip'
import { FlatButton } from 'material-ui'
import {RouteComponentProps} from 'react-router';
import {History} from 'history';
import LocationDescriptor = History.LocationDescriptor;

interface SetAvailabilityState {
  jobs: Job[]
  isJobsReceived: boolean
  todayDate: moment.Moment
  daysArray: Days[]
  selectedChips: String[]
  selectedTimes: Slots[]
  isInfoDialogOpen: boolean
  month: string | null
  year: number | null
  tempMonth: string | null
  tempYear: number | null
}

interface SetAvailabilityProps {
  onSetCompletedJob: (completedJob: Job) => void
  routePush: (location: LocationDescriptor) => RouterAction
  setSlots: (slots: Slots[]) => void
  setChips: (chips: String[]) => void
  setJobTimeInfo: (isJobTimeInfoShown: boolean) => void
  completedJob: Job | null
  slots: Slots[]
  chips: String[]
  isJobTimeInfoShown: boolean,
  removeJobDetails: () => void
}

type Props = SetAvailabilityProps & RouteComponentProps<any>;

export class SetAvailabilityContainer extends React.Component<Props, SetAvailabilityState> {
  constructor(props) {
    super(props)
    this.state = {
      jobs: [],
      isJobsReceived: false,
      todayDate: moment(),
      daysArray: this.getDays(),
      selectedChips: this.props.chips,
      selectedTimes: this.props.slots,
      isInfoDialogOpen: false,
      month: moment().format('MMM').toUpperCase(),
      year: moment().year(),
      tempMonth: null,
      tempYear: null
    }
  }

  componentDidMount() {
    let todayTime = moment().hour()
    let index = TIMES_2.findIndex(item => /*todayTime < item.timeFrom && */todayTime < item.timeTo)
    let todayDate = moment()

    if (index === -1) {
      todayDate = moment().add(1, 'days')
      this.setState({
        todayDate: todayDate
      })
    }

    if (!this.props.slots || (this.props.slots && this.props.slots.length === 0)) {
      this.defaultSelectedChips(todayDate, index)
    }

    if (!this.props.isJobTimeInfoShown) {
      this.setState({
        isInfoDialogOpen: true
      })
    }
  }

  defaultSelectedChips = (todayDate: moment.Moment, index: number) => {
    let time
    let day = todayDate.date()
    let selectedTime: Slots
    let firstTimeId = index === -1 ? 0 : index
    let maxId = TIMES_2.length

    let chipsTempArray: String[] = []
    let selectedTimesTempArray: Slots[] = []

    for (let i = firstTimeId; i < maxId; i++) {
      time = TIMES_2.find(item => item.id === i)!
      selectedTime = {
        dateFrom: todayDate.startOf('day').add(time.timeFrom, 'hours').valueOf(),
        dateTo: todayDate.startOf('day').add(time.timeTo, 'hours').valueOf()
      }
      if(this.isFromNow(time, day))
        selectedTime.isNow = true;

      selectedTimesTempArray.push(selectedTime)
      chipsTempArray.push(`${day}${i}`)
    }

    this.setState({
      selectedChips: chipsTempArray,
      selectedTimes: selectedTimesTempArray
    })
    this.props.setChips(chipsTempArray)
    this.props.setSlots(selectedTimesTempArray)
  }

  handleChipClick = (event) => {
    let selectedChip = `${event.currentTarget.id}${event.currentTarget.title}`

    let tempArray = this.props.chips
    let tempSelectedTimes = this.state.selectedTimes

    let index = tempArray.findIndex(item => item === selectedChip)

    let day = this.state.daysArray.find(item => `${item.day}` === event.currentTarget.id)!
    let time = TIMES_2.find(item => `${item.id}` === event.currentTarget.title)!
    let selectedTime:Slots = {
      dateFrom: moment(day.date).add(time.timeFrom, 'hours').valueOf(),
      dateTo: moment(day.date).add(time.timeTo, 'hours').valueOf()
    }

    if(this.isFromNow(time,day.day))
      selectedTime.isNow = true;

    let slotIndex = tempSelectedTimes.findIndex(item => {
      return moment(item.dateFrom).date() === day.day && moment(item.dateFrom).hour() === time.timeFrom
    })

    if (index !== -1 && slotIndex !== -1) {
      tempArray.splice(index, 1)
      tempSelectedTimes.splice(slotIndex, 1)
    } else {
      tempArray.push(selectedChip)
      tempSelectedTimes.push(selectedTime)
    }
    this.setState({
      selectedChips: tempArray,
      selectedTimes: tempSelectedTimes
    })

    this.props.setChips(tempArray)
    this.props.setSlots(tempSelectedTimes)
  }

  getDays = () => {
    let daysArray: Days[] = []
    let i: number
    let day: number
    let maxFutureDate: number = 6
    let todayTime = moment().hour()
    let index = TIMES_2.findIndex(item => todayTime < item.timeTo)

    if (index === -1) {
      i = 1
      maxFutureDate = 7
    } else {
      i = 0
    }

    for (i; i <= maxFutureDate; i++) {
      day = moment().add(i, 'days').date()
      daysArray.push({ day: day, date: moment().startOf('day').add(i, 'days').valueOf() })
    }
    return daysArray
  }

  getDayOfWeek = (date: number) => {
    let dayOfWeek = moment(date).format('ddd')
    return dayOfWeek.toUpperCase()
  }

  getChip = (day: number) => {
    let time = moment().hour()
    let index = TIMES_2.findIndex(item => /*time < item.timeFrom && */time < item.timeTo)
    if (index === -1 || day !== this.state.todayDate.date()) {
      index = 0
    }

    return (
      TIMES_2.map(item => {
        if (index <= item.id) {
          return (
            <div
              key={item.id}
              id={`${day}`}
              title={`${item.id}`}
              className={`chip`}
              onClick={this.handleChipClick}
            >
              <Chip
                label={this.getLabel(item.id, day)}
                variant="outlined"
                className={
                  this.state.selectedChips && this.state.selectedChips.find(selectedTime => selectedTime === `${day}${item.id}`) ?
                    'time-chip chip-selected' : 'time-chip'}
              />
            </div>
          )
        }
      })
    )
  }

  isFromNow = (item, day) => {
    const now = moment()
    const nowDay = now.date()
    if (nowDay !== day) {
      return false
    }
    const nowHour = now.hour()
    return item.timeFrom <= nowHour && nowHour < item.timeTo
  }
  getLabel(id, day) {
    const item = TIMES_2[id]
    const from = this.isFromNow(item, day) ? 'Now' : (item.timeFrom % 12)
    const to = item.timeTo % 12
    const ampm = item.timeTo > 12 ? 'pm' : 'am'

    return `${from} - ${to} ${ampm}`
  }

  handleNextButtonClick = () => {
    this.props.setSlots(this.state.selectedTimes)
    this.props.setChips(this.state.selectedChips)
    this.props.routePush({pathname: ROUTES.PUBLISHED_JOB, state: this.props.location.state})
  }

  goBack = () => {
   console.log('goback ' + JSON.stringify(this.props.location.state))
    if(!!this.props.location.state && this.props.location.state['repost']){
      this.props.removeJobDetails();
    }
    else {
      this.props.setChips([])
      this.props.setSlots([])
    }

    history.back()
  }

  handleInfoDialogClose = () => {
    this.props.setJobTimeInfo(true)
    this.setState({
      isInfoDialogOpen: false
    })
  }

  onScrollUp = () => {
    const element = document.getElementById('middle-header')
    if (element !== null) {
      let rect = element.getBoundingClientRect()
      if (rect.top <= 112) {
        this.setState({
          month: this.state.tempMonth,
          year: this.state.tempYear
        })
      } else {
        this.setState({
          month: null,
          year: null
        })
      }
    }
  }

  setTempMonthYear = (date) => {
    if (this.state.tempMonth === null) {
      this.setState({
        tempMonth: moment(date).format('MMM').toUpperCase(),
        tempYear: moment(date).year()
      })
    }
  }

  render() {
    const isButtonDisabled = this.state.selectedTimes && this.state.selectedTimes.length === 0 ? true : false
    const resetJobDetailsOnGoBack = !!this.props.location.state && this.props.location.state['repost'];

    return (
      <BaseContainer pageName={EventType.SET_AVAILABILITY}>

        <InfoDialog
          isInfoDialogOpen={this.state.isInfoDialogOpen}
          isJobTimeInfo={true}
          handleInfoDialogClose={this.handleInfoDialogClose}
        />

        <AppBarContainer
          isIconButtonsShown={true}
          isMenuShown={false}
          resetStore={resetJobDetailsOnGoBack}
        />
        <PageTitle text={StringResources.getString(Strings.SetAvailability.Title)} />
        <div className="date-time-header" id="top-header">
          <span className="date-time-header-text">{this.state.month !== null ? this.state.month : moment().format('MMM').toUpperCase()}</span>
          <span className="date-time-header-operation">{this.state.year !== null ? this.state.year : moment().year()}</span>
        </div>
        {/* <LoadingSpinner show={!this.state.isJobsReceived} /> */}
        <div className="available-times">
          <PerfectScrollbar className="completed-jobs-scroll" onScrollY={this.onScrollUp} >
            {
              this.state.daysArray.map((item: Days) => (
                <div key={item.day}>
                  {
                    moment(item.date).month() !== moment().month() && item.day === 1 ?
                      <div className="date-time-header date-time-middle-header" id="middle-header">
                        {this.setTempMonthYear(item.date)}
                        <span className="date-time-header-text">{moment(item.date).format('MMM').toUpperCase()}</span>
                        <span className="date-time-header-operation">{moment(item.date).year()}</span>
                      </div> : null
                  }
                  <ListItem
                    className="days-list-item"
                  >
                    <Avatar
                      classes={{ root: 'date-avatar' }}
                      alt={`${item.day}`}
                    >
                      <p className="small-text">{this.getDayOfWeek(item.date)}</p>
                      <p>{`${item.day}`}</p>
                    </Avatar>
                    <ListItemText
                      primary={this.getChip(item.day)}
                    />
                  </ListItem>
                </div>
              ))}
          </PerfectScrollbar>
        </div>
        <StickyContainer className={'sticky-footer'} >
          <Sticky>
            {() => (
              <div className={'bottom-part hover'}>
                <FlatButton
                  label={StringResources.getString(Strings.PublishedJob.Buttons.Back.label)}
                  className={'flatbutton'}
                  onClick={this.goBack}
                />
                <FlatButton
                  label={`Next`}
                  className={isButtonDisabled ? 'flatbutton disabled' : 'flatbutton'}
                  onClick={this.handleNextButtonClick}
                  disabled={isButtonDisabled}
                />
              </div>
            )}
          </Sticky>
        </StickyContainer>
      </BaseContainer>
    )
  }
}

function mapStateToProps(state: StoreState) {
  return {
    routing: state.routing,
    completedJob: state.completedJob,
    slots: state.jobDetails.slots,
    chips: state.jobDetails.chips,
    isJobTimeInfoShown: state.jobDetails.isJobTimeInfoShown
  }
}

function mapDispatchToProps(dispatch: any) {
  return {
    routePush: (location: LocationDescriptor) => dispatch(routerActions.push(location)),
    onSetCompletedJob: (completedJob: Job) => dispatch(setCompletedJob(completedJob)),
    setSlots: (slots: Slots[]) => dispatch(setSlots(slots)),
    setChips: (chips: String[]) => dispatch(setChips(chips)),
    setJobTimeInfo: (isJobTimeInfoShown: boolean) => dispatch(setJobTimeInfo(isJobTimeInfoShown)),
    removeJobDetails: () => dispatch(removeJobDetails())
  }
}

export const SetAvailability = connect(
  mapStateToProps,
  mapDispatchToProps
)(SetAvailabilityContainer)



// WEBPACK FOOTER //
// ./src/containers/SetAvailability.tsx